import "core-js/modules/es.array.push.js";
import * as rrweb from 'rrweb';
import loginErrorModal from './loginErrorModal';
export default {
  components: {
    loginErrorModal
  },
  data() {
    return {
      accounts: JSON.parse(sessionStorage.getItem('multipleAccounts')) || [],
      loginInfo: JSON.parse(sessionStorage.getItem('loginInfo')),
      loginErrorVisible: false,
      contactWay: JSON.parse(sessionStorage.getItem('contactWay')) || {},
      cancellationTime: ''
    };
  },
  methods: {
    goIndex(val) {
      this.loginInfo.account = val.account;
      this.$store.dispatch('user/login', this.loginInfo).then(res => {
        var _res$data;
        if (res.code !== 200) {
          return this.$message.error(this.$t(res.message));
        }
        console.log(res, '多账号页面登陆res');
        // 判断账号是否注销-用户状态：true 注销 false 正常
        if ((_res$data = res.data) !== null && _res$data !== void 0 && _res$data.logOffStatus) {
          this.loginErrorVisible = true;
          this.cancellationTime = res.cancellationTime;
          return;
        }
        this.$router.push({
          path: '/index'
        });
        sessionStorage.setItem('loginTime', new Date().getTime());
        clearInterval();
        let stopFun = this.$store.state.user.recordInstance;
        if (stopFun && typeof stopFun === 'function') {
          stopFun();
        }
        this.$store.commit('user/CLEAR_TRACEBACK_EVENTS');
        if (this.$store.state.user.pauseInstance) {
          clearTimeout(this.$store.state.user.pauseInstance);
        }
        // let stopFn = rrweb.record({
        //   emit(event) {
        //     setTimeout(() => {
        //       stopFn();
        //     }, 100);
        //   }
        // });
        // this.$store.dispatch('user/setUploadTrackback');
      });
    }
  }
};